import React, { useRef, useState } from "react";
import { useDebounceCallback } from "@react-hook/debounce";
import { connect } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";
import ReactMarkdown from "react-markdown";
import { clone, values, prop, any, isEmpty } from "ramda";
import {} from "lodash";
import {
  MultiValueForm,
  Content,
  ContentBlock
} from "@onelogin/react-components";
import FormField from "./FormField";
import LargeButton from "./LargeButton";
import { verify as verifyAction } from "../actions/verifyActions";
import { EMAIL_OTP } from "../constants/RegistrationTypes"; 
import { resendOtp as resendOtpAction } from "../actions/resendOtpActions";

const VerifyOtpForm = ({ email, accountId, verify, resendOtp, intl }) => {
  const formRef = useRef();

  // Checking that all form values are filled before the Register button is clickable
  const [disabled, setDisabled] = useState(true);
  const checkDisabled = useDebounceCallback(() => {
    const formValues = values(formRef.current.state).map(prop("value"));
    setDisabled(any(isEmpty, formValues));
  }, 250);

  const otpHelpText = "We have sent an email containing an OTP code to your registered email address. Please enter the code here to complete verification.";
  const onSubmit = () => {
    const { userCode } = clone(
      formRef.current.state
    );
    const otpCode = userCode.value; 
    const type = EMAIL_OTP; 
    verify({
      email,
      otpCode,
      accountId, 
      type
    });
  };

  const tryAgain = () => {
    const type = EMAIL_OTP; 
    resendOtp({
      email, 
      type, 
      accountId
    }); 
  }; 

  const fieldIds = [
    "userCode"
  ]

  return (
    <MultiValueForm
          ref={formRef}
          fieldNames={fieldIds}
          onSubmit={() => {}} // Not using the MultiValueForm's submit because it can't be called programatically
          render={fields => (
            <Content data-testid="self-registration-otp-form">
              <ContentBlock>
                <ReactMarkdown>{otpHelpText}</ReactMarkdown>
              </ContentBlock>
            
              <FormField
                key="userCode"
                fieldId="userCode"
                fieldLabel={intl.formatMessage({
                  id: "userCode",
                  defaultMessage: "OTP Code"
                })}
                onChange={e => {
                  fields.userCode.onChange(e.target.value);
                  checkDisabled();
                }}
                value={fields?.userCode?.value || ""}
              />

              <ContentBlock>
                <LargeButton
                  onClick={() => tryAgain()}
                  size="large"
                  look="secondary"
                >
                  <FormattedMessage id="try_again" defaultMessage="Try Again" />
                </LargeButton>
                <LargeButton
                  onClick={() => onSubmit()}
                  size="large"
                  look="primary"
                  disabled={disabled}
                >
                  <FormattedMessage id="submit" defaultMessage="Continue" />
                </LargeButton>
              </ContentBlock>

            </Content>
          )}
        />
      );
};

const mapStateToProps = state => ({
  registration: state.registration.data
});

const mapDispatchToProps = dispatch => ({
  verify: data => dispatch(verifyAction(data)),
  resendOtp: data => dispatch(resendOtpAction(data))
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(VerifyOtpForm)
);
